import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center w-full justify-between" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "flex w-full gap-2 mb-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "pl-2",
  style: {"min-width":"200px"}
}, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1" }, "Target")
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "font-bold color-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_TableCourierComissionIndex = _resolveComponent("TableCourierComissionIndex")
  const _component_CourierComissionForm = _resolveComponent("CourierComissionForm")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, { class: "mb-5" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h6", _hoisted_2, _toDisplayString(_ctx.data?.MsKotaNama), 1),
          _createVNode("i", {
            class: "pi pi-ellipsis-h cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropDown($event)))
          })
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, _toDisplayString(_ctx.data.Target) + " resi", 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.Id && _ctx.showTables)
      ? (_openBlock(), _createBlock(_component_TableCourierComissionIndex, {
          key: 0,
          Id: _ctx.Id,
          DataHd: _ctx.data
        }, null, 8, ["Id", "DataHd"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CourierComissionForm, {
          dataEdit: _ctx.data,
          onReloadData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDataDetail())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["dataEdit", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: _ctx.route.meta.permission.delete,
          edit: _ctx.route.meta.permission.update,
          onDel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteData(_ctx.data.Id))),
          onEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editData(_ctx.data)))
        }, null, 8, ["del", "edit"])
      ]),
      _: 1
    }, 512)
  ]))
}